export default {
    default: {
        rootUrl: null, // Spécifie la route url pour ce connecter à l'api concrete
        apiToken: null, // spécifie le token nécessaire pour ce connecter à concrete
        fetchModelsConstantly: 10000, // définit le temps en ms entre chaque fetch
        fetchModelsPeriod: 60000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        nafs: {
            url: 'naf/'
        },
        factoryEngines: {
            url: 'motor/',
            filter: {
                archived: false
            }
        },
        simulations: {
            url: 'simulation/',
            filter: {
                archived: false,
            },
            fetch: false
        },
        simulationsTotal: {
            url: 'simulation/',
            fetch: false
        },
        factories: {
            url: 'factory/',
            filter: {
                archived: false
            }
        },
        switchEngines: {
            url: 'switch-motor/',
        },
        creationRequests: {
            url: 'creation-request/',
        },
        reports: {
            url: 'report/',
            fetch: false
        },
        modelReports: {
            url: 'model-report/',
        },
        auditReports: {
            url: 'audit-report/',
            fetch: false
        },
        simulationUsages: {
            url: 'simulation-usage/',
            fetch: false
        },
        importableMotors: {
            url: 'importable-motor/',
            fetch: false
        }

    }, // liste les models que l'on souhaite être rendus dans les vues génériques
};



// WEBPACK FOOTER //
// ./src/store/meta.js